/**
 * Codeblock.js
 * Simple codeblock, just feed some code to the children and it will do it's magic.
 *
 * @class   Codeblock
 * @author  Yevgeniy Rokhlin
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import hljs from 'highlight.js';

export default class Codeblock extends React.Component {

	displayName: 'Codeblock'

	componentDidMount() {
		hljs.highlightBlock(React.findDOMNode(this));
	}

	componentDidUpdate(prevProps, prevState) {
    	hljs.highlightBlock(React.findDOMNode(this));
	}

	render() {

		return (
			<pre className="lui-code-block">
				<code>{this.props.children}</code>
			</pre>
		);
	}

};



/** WEBPACK FOOTER **
 ** ./src/components/codeblock/Codeblock.js
 **/